// removed by extract-text-webpack-plugin
module.exports = {"tooltip":"tooltip__tooltip___3Zdae","tooltipActive":"tooltip__tooltip--active___2puQS tooltip__tooltip___3Zdae"};


//////////////////
// WEBPACK FOOTER
// ./src/js/components/tooltip/tooltip.scss
// module id = 193
// module chunks = 0 1